import { login, getUserInfo, logout, livenessDetect } from '@/api/sign'
import { MessageBox, Message } from "element-ui";

const state = {
  userInfo: {},
  token: localStorage.getItem('SIGN_TOKEN') || '',
  isLogin: false,
  txSn: localStorage.getItem("txSn")
}
const mutations = {
  setTx (state, txSN) {
    state.txSn = txSN
    localStorage.setItem('txSn', txSN)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_TOKEN: (state, token) => {
    localStorage.setItem('SIGN_TOKEN', token)
    state.token = token
  },
  SET_LOGIN: (state, isLogin) => {
    state.isLogin = isLogin
  },
}
const actions = {
  handlelogin({ commit, state }, userInfo) {
    commit('SET_TOKEN', userInfo.token)
    return new Promise((resolve, reject) => {
      login( userInfo ).then(res => {
        const { data, code, msg } = res
        console.log(data)
        resolve(data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  // 获取用户信息接口
  async getUserInfo ({ commit, dispatch }) {
    const { code, data, msg } = await getUserInfo()
    if (code != 0) {
      await dispatch('resetAll')
      Message({
        message: `${msg}`,
        type: "error",
        duration: 5 * 1000,
      });
      return
    }

    if (data.realNameDelayDays == -2147483648) {
      data.isNewClient = true;
    } else {
      data.isNewClient = false;
    }
    dispatch('setUser', data)
    commit('SET_LOGIN', true)
  },
  // 设置用户信息
  async setUser ({ state, commit }, payload = {}) {
    const userInfo = {
      ...state.user,
      ...payload
    }
    commit('SET_USER_INFO', userInfo)
  },
  // 退出登录
  async logout ({ dispatch }) {
    await dispatch('resetAll')
    await logout()
  },
  // 重置token、router等
  async resetAll ({ commit, dispatch }) {
    commit('SET_LOGIN', false)
    dispatch('setUser', null)
    commit('setTx', '')
    commit('SET_TOKEN', '')
    localStorage.removeItem('')
    localStorage.removeItem('txSn')
  },
  /**
   * 实名认证去
   * @param {} param0
   */
  async goCheckFace ({ commit }) {
    const params = {
      frontUrl: 'http://localhost:9527/#/personal/authback',
      frontMethod: '1',
      remark: '',
    }
    const { code, msg, data } = await livenessDetect(params)
    if (code == 0) {
      commit('setTx', data.txSN)
      window.location.href = data.url
    } else {
      Message({
        message: `${msg}`,
        type: "error",
        duration: 5 * 1000,
      });
    }
  },
  /**
  * 提醒消息
  */
  getUserDetailNoteTitle () {
    if (userInfo.isNewClient) {
      return "您尚未完成实名认证及注册安心签，请您完成实名认证、注册安心签并签署服务协议。";
    } else {
      if (userInfo.memberType == "1") {
        //个人
        if (userdetail.realNameDelayDays > 0) {
          return "您尚未完成实名认证及注册安心签，请您在 " +
            userdetail.realNameDelayDays.toString() +
            " 天内完成实名认证、注册安心签并签署服务协议，否则将无法继续使用本系统进行采购销售。";
        } else {
          return "您尚未完成实名认证及注册安心签，请您完成实名认证、注册安心签并签署服务协议，否则将无法继续使用本系统进行采购销售";
        }
      } else {
        //企业
        if (userInfo.realNameDelayDays > 0) {
          return "您尚未注册安心签，请您在 " +
          userInfo.realNameDelayDays.toString() +
            " 天内完成注册并签署服务协议，否则将无法继续使用本系统进行采购销售";
        } else {
          return "您尚未注册安心签，请您注册并签署服务协议，否则将无法继续使用本系统进行采购销售";
        }
      }
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
